import React from 'react';
import cx from '../../../styles';

export const PlaceholderMainImage = () => {
	return (
		<div className={cx('content-placeholder', 'placeholder-main-image', 'animated-background')}></div>
	)
}

const PlaceholderTitle = () => {
	return (
		<div className={cx('content-placeholder', 'placeholder-title')}>
			<div className={cx('animated-background')}></div>
			<div className={cx('animated-background')}></div>
		</div>
	)
}

const PlaceholderWord = () => {
	return (
		<div className={cx('content-placeholder', 'placeholder-word', 'animated-background')}></div>
	)
}

const PlaceholderTextbox = () => {
	return (
		<div className={cx('content-placeholder', 'placeholder-textbox', 'animated-background')}></div>
	)
}

const PlaceholderIcon = () => {
	return (
		<div className={cx('content-placeholder', 'placeholder-icon', 'animated-background')}></div>
	)
}

const PlaceholderList = () => {
	return (
		<ul className={cx('content-placeholder', 'placeholder-list')}>
			<li>
				<PlaceholderWord />
			</li>
			<li>
				<PlaceholderWord />
			</li>
			<li>
				<PlaceholderWord />
			</li>
		</ul>
	)
}

export const ArticleCardPlaceholder = () => {
	return (
		<div className={cx('content-placeholder', 'article-card-placeholder')}>
			<div className="timeline-item">
	        	<PlaceholderMainImage />
	        	<PlaceholderTitle />
		    </div>
		</div>
	)
}

export const FeedPostPlaceholder = () => {
	return (
		<div className={cx('feed-post-placeholder', 'content-placeholder')}>
			<div className={cx('timeline-item')}>
				<div className={cx('post-topic-wrapper', 'flex')}>
					<div className={cx('post-topic', 'animated-background')}></div>
					<PlaceholderWord />
				</div>
				<div className={cx('post-wrapper')}>

					<div className={cx('title')}>
						<PlaceholderTitle />
					</div>
					<div className={cx('description')}>
						<PlaceholderWord />
						<PlaceholderWord />
						<PlaceholderWord />
					</div>
					<div className={cx('flex', 'flex-full-width', 'reply-section')}>
						<aside className={cx('left')}>
							<PlaceholderIcon />
						</aside>
						<aside className={cx('right')}>
							<PlaceholderTextbox />
						</aside>
					</div>
				</div>
			</div>
		</div>
	)
}

export const RecipeDetailPlaceholder = () => {
    return(
        <div className={cx('recipe-detail-placeholder', 'content-placeholder')}>
            <PlaceholderMainImage />
            <div className={cx('category-detail-wrap')}>
            	<PlaceholderTitle />
                <div className={cx('tag-wrap')}>
    				<div className={cx('recipe-tag', 'animated-background')}></div>
    				<div className={cx('recipe-tag', 'animated-background')}></div>
                </div>
                <div className={cx('properties-wrap')}>
					<PlaceholderWord />
					<PlaceholderWord />
					<PlaceholderWord />
					<PlaceholderWord />
            	</div>
            </div>
            <div className={cx('recipe-detail-wrap')}>
			    <span className={cx('title')}>
			    	<PlaceholderWord />
			    </span>
        		<PlaceholderList />

        		<span className={cx('title', 'steps')}>
			    	<PlaceholderWord />
			    </span>
        		<PlaceholderList />
    		</div>
        </div>
    )
}

export const RecipeCardPlaceholder = () => {
	return (
		<div className={cx('content-placeholder', 'recipe-card-placeholder', 'each-recipe')}>
			<div className={cx('recipe-image', 'animated-background')}>

			</div>
			<div className={cx('recipe-details-wrap')}>
				<PlaceholderTitle />
				<span className={cx('recipe-tags')}>
					<PlaceholderWord />
				</span>
				<span className={cx('recipe-properties')}>
					<PlaceholderWord />
					<PlaceholderWord />
				</span>
			</div>
		</div>
	)
}

export const RecipeCategoryPlaceholder = () => {
	return (
		<div className={cx('content-placeholder', 'recipe-category-placeholder')}>
			<PlaceholderMainImage />
			<PlaceholderMainImage />
			<PlaceholderMainImage />
		</div>
	)
}

export const RecipesLandingPlaceholder = () => {
	return (
		<div className={cx('content-placeholder', 'recipes-landing-placeholder')}>
			<div>
				<PlaceholderWord />
				<div className={cx('categories')}>
					<PlaceholderMainImage />
					<PlaceholderMainImage />
					<PlaceholderMainImage />
					<PlaceholderMainImage />
					<PlaceholderMainImage />
				</div>
			</div>
			<div>
				<PlaceholderWord />
				<div className={cx('categories')}>
					<PlaceholderMainImage />
					<PlaceholderMainImage />
					<PlaceholderMainImage />
					<PlaceholderMainImage />
					<PlaceholderMainImage />
				</div>
			</div>
		</div>
	)
}

export const NotificationLinksPlaceholder = () => {
	return (
		<ul className={cx('content-placeholder', 'notification-links-placeholder')}>
			<li className={cx('each-link', 'flex')}>
                <PlaceholderIcon />
                <PlaceholderTitle />
            </li>
            <li className={cx('each-link', 'flex')}>
                <PlaceholderIcon />
                <PlaceholderTitle />
            </li>
            <li className={cx('each-link', 'flex')}>
                <PlaceholderIcon />
                <PlaceholderTitle />
            </li>
		</ul>
	)
}